<div
  class="slice-sticky"
  *ngIf="!keepClosed"
  [ngClass]="{
    'slice-sticky--aligned': slice?.settings?.general?.alignCloseButton
  }"
  [ngStyle]="{
    'background-color': slotBackgroundColor
  }"
>
  <div
    #slotsWrapper
    *ngFor="let slot of slots; let i = index; trackBy: trackByIndex"
    class="slot-wrapper"
    [ngClass]="{
      'slot-wrapper--one-line': slice?.settings?.general?.showInOneLine,
      'slot-wrapper--close-button': slice?.settings?.general?.showCloseButton,
      'slot-wrapper--animated': slice?.settings?.general?.animatedTexts,
      'slot-wrapper--active': currentSlot === i
    }"
  >
    <div
      #progressbar
      *ngIf="slice?.settings?.general?.animatedTexts && slice?.settings?.general?.progressBar"
      class="progress-bar"
      [ngClass]="{'progress-bar--active': currentSlot=== i}"
      [ngStyle]="{
        'background-color': slice?.settings?.styles?.progressBarStyles?.color || '#000000',
        'animation-duration': animationTime + 's' || '2s'
      }"
    >
    </div>
    <render-slice-slot
      #contentSlots
      data-e2e="render-slice-slot"
      class="slot"
      [ngClass]="{
        'slot--active': currentSlot === i,
        'slot--one-line': slice?.settings?.general?.showInOneLine,
        'slot--animated-text': shouldAnimateText
      }"
      [slice]="slice"
      [slot]="i + 1"
      [hidden]="slot.hidden"
      [ngStyle]="{
        'flex-grow': stylePropOrDefault(slot.flexGrow, '0'),
        'flex-shrink': stylePropOrDefault(slot.flexShrink, '1'),
        'flex-basis': stylePropOrDefault(slot.flexBasis, 'auto'),
        'flex-direction': stylePropOrDefault(slot.flexDirection, 'row'),
        'width': shouldAnimateText ? 'fit-content' : stylePropOrDefault(slot.width, '100%'),
        'height': stylePropOrDefault(slot.height, 'auto'),
        'min-height': slot.minHeight,
        'max-height': slot['max-height'],
        'min-width': slot.minWidth,
        'max-width': shouldAnimateText ? 'fit-content' : slot.maxWidth,
        'animation-duration': animationTime + 's' || '2s'
      }"
    >
    </render-slice-slot>
  </div>
  <button
    *ngIf="slice?.settings?.general?.showCloseButton"
    type="button"
    (click)="close()"
    class="close-button e2e-close-button oysho-icon-close"
    [attr.aria-label]="'Cerrar sticky'"
    [ngStyle]="{
      'color': slice?.settings?.styles?.closeButton?.color || '#000',
      'background-color': slotBackgroundColor
    }"
    [ngClass]="{
      'close-button--aligned': slice?.settings?.general?.alignCloseButton,
      'close-button--top': !slice?.settings?.general?.showInOneLine
    }"
  >
  </button>
</div>
